import React, { useState, useCallback } from 'react';
import {
    Button,
    Header,
    Icon,
    Modal
} from 'semantic-ui-react';

const ErrorContext = React.createContext({
    error: null,
    showError: () => {},
    hideError: () => {}
});

export function useError() {
    return React.useContext(ErrorContext);
}

const ErrorNotification = () => {
    const { error, hideError } = useError();

    const handleSubmit = () => {
        if (error && error.onClose) {
            error.onClose();
        }
        hideError();
    };

    return (
        <Modal
            basic
            onClose={handleSubmit}
            open={!!error}
        >
            <Header icon>
                <Icon name={error && error.icon ? error.icon : 'warning sign'} />
                {error && error.title ? error.title : 'Error'}
            </Header>
            <Modal.Content>
                {error && error.message ? <>{error.message}</> : 'Unspecified error'}
            </Modal.Content>
            <Modal.Actions>
                <Button basic color='red' inverted onClick={handleSubmit}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

export function ErrorProvider({ children }) {
    const [ error, setError ] = useState(null);

    const hideError = () => setError(null);
    const showError = (title, message, icon, onClose) => {
        setError({ title, message, icon, onClose });
    }

    const contextValue = {
        error,
        showError: useCallback((title, message, icon, onClose) => showError(title, message, icon, onClose), []),
        hideError: useCallback(() => hideError(), [])
    };

    return (
        <ErrorContext.Provider value={contextValue}>
            {children}
            <ErrorNotification />
        </ErrorContext.Provider>
    )
}